<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="grid"
        title="수질자동측정기기 등의 측정항목별 점검내용"
        tableId="grid"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="false"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
        :editable="editable"
        :gridHeightAuto="param.isFullScreen"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="LBLSAVE" icon="save" v-if="!param.isFullScreen && editable" @btnClicked="saveData"/>
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-report-11',
  props: {
    param: {
      type: Object,
      default: () => ({
        plantCd: null,
        envWaterDailyResultId: '',
        isFullScreen: false,
        dailyResultDt: '',
        approvalStatusCd: null,
        approvalTarget: false,
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'waterDailyMeasureName',
            field: 'waterDailyMeasureName',
            label: '구분',
            align: 'center',
            sortable: false,
          },
          {
            name: 'oprState01',
            field: 'oprState01',
            label: 'pH',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState02',
            field: 'oprState02',
            label: 'BOD',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState03',
            field: 'oprState03',
            label: 'TOC',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState04',
            field: 'oprState04',
            label: 'COD',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState05',
            field: 'oprState05',
            label: 'SS',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState06',
            field: 'oprState06',
            label: 'n-Hex',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState07',
            field: 'oprState07',
            label: 'Cu',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState08',
            field: 'oprState08',
            label: '유량계',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
          {
            name: 'oprState09',
            field: 'oprState09',
            label: '시료채취조',
            align: 'center',
            type: 'text',
            style: 'width:8%',
            sortable: false,
          },
        ],
        height: '600px',
        data: [],
      },
      listUrl: '',
      saveUrl: '',
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  computed: {
    editable() {
      if (this.param.approvalTarget) {
        return true;
      } else if (this.param.approvalStatusCd !== null) {
        return false;
      } else {
        return this.$route.meta.editable
      }
    },
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.env.water.daily.measure.list.url;
      this.saveUrl = transactionConfig.env.water.daily.measure.save.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {envWaterDailyResultId: this.param.envWaterDailyResultId, plantCd: this.param.plantCd};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    saveData() {
      let saveData = this.grid.data.filter( x => {
        return x.editFlag == 'U' || x.editFlag == 'C'
      });
      this.$_.forEach(saveData, item => {
        item.regUserId = this.$store.getters.user.userId;
        item.chgUserId = this.$store.getters.user.userId;
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.saveUrl;
            this.$http.type = 'POST';
            this.$http.param = saveData;
            this.$http.request(() => {
              this.getList();
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '저장되었습니다.', /* 저장되었습니다. */
                type: 'success', // success / info / warning / error
              });
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: 'MSGNOCHANGEDATA', // 변경된 데이터가 없습니다., /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    },
  }
};
</script>
